import { Form } from "@circle-react-uikit/Form";

import { useUpdateComment } from "@/react/components/CommentsCompass/data/useUpdateComment";
import type { TrixFormValues } from "@/react/components/CommentsCompass/types";
import { useModal } from "@/react/components/Layout/ModalManagerProvider";
import type { Comment } from "@/react/types/Comment";

import { FORM_ID, TrixEditBody } from "./TrixEditBody";

interface TrixEditModalProps {
  comment: Comment;
  spaceId: number;
}

export const TrixEditModal = ({ comment, spaceId }: TrixEditModalProps) => {
  const modal = useModal();
  const { updateComment } = useUpdateComment({
    comment,
    onSuccess: () => void modal.hide(),
  });

  return (
    <Form<TrixFormValues>
      id={FORM_ID}
      defaultValues={{ body: comment.body_for_editor }}
      onSubmit={async formData => {
        await updateComment(formData);
      }}
      preventAccidentalLeave
    >
      <TrixEditBody spaceId={spaceId} />
    </Form>
  );
};
